import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// F1 — ‏מיובא **ראשון** בכוונה: קוד-האתחול שלו קובע את `<html lang/dir>` לפי
// ‏`?lang=`/localStorage לפני שהרינדור הראשון מצייר משהו, כך שאין הבזק של
// כיווניות שגויה במעבר לרוסית/אנגלית.
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installDevMock } from './mock/devMock';
import { installAppHeight } from './utils/appHeight';

// Lock the layout to the REAL visible-viewport height (not the unreliable 100dvh)
// so the appointment screen's fixed calendar + internal time-scroll + pinned CTA
// never overflow under the browser's URL-bar / toolbar on real phones.
installAppHeight();

// Local dev only (no-op unless REACT_APP_DEV_MOCK=1 on localhost).
installDevMock();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();